// home banner slider
$(document).ready(function() {
   $('.home_banner_slider').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:3,
		autoplay: false,
        nav:false,
        // autoplayTimeout: 6000,
        // smartSpeed: 1400,
		dots: true,
		dotsEach: 1,
		responsiveClass: true,
        // autoHeight: true,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 1,
			nav: false,
           
		  },
          390:{
            items: 1,
			nav: false,
           
          },
          600:{
            items: 1,
			nav: false
          },
          768:{
            items: 1,
			nav: false
          },
          991:{
            items: 1,
			nav: false,
          
          },
         1024:{
            items: 1,
			nav: true,
          
          },
          1440:{
            items:1,
			nav: true
          }
          
		  
		}
	})
 })
$(document).ready(function() {
    var owl1 = $('.home_banner_slider');
    owl1.owlCarousel();
    
    $('.left-arrow').click(function () {
        owl1.trigger('prev.owl.carousel');
    });
    
    $('.right-arrow').click(function () {
        owl1.trigger('next.owl.carousel');
    });
});


$(document).ready(function() {
   $('.logo-section').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:7,
		autoplay: true,
        nav:false,
        autoplaySpeed: 4500,
        slideTransition: 'linear',
        autoplayTimeout: 5000,
        lazyLoad: true,
		dots: false,
		dotsEach: 1,
		responsiveClass: true,
        autoHeight: false,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 3,
			nav: false
		  },
          390:{
            items: 3,
			nav: false
          },
          600:{
            items: 4,
			nav: false
          },
          768:{
            items: 4,
			nav: false
          },
          991:{
            items: 6,
			nav: true
          },
         1024:{
            items: 4,
			nav: true
          },
          1200:{
            items: 7,
			nav: true
          }
		  
		}
	});
 });


//popup slider.....
$(document).ready(function() {
   $('.popup-slider').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:3,
		// autoplay: true,
        nav:false,
        autoplayTimeout: 4000,
        smartSpeed: 1400,
		dots: false,
		dotsEach: 1,
		responsiveClass: true,
        autoHeight: false,
        stagePadding: 100,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 1,
			nav: false,
            stagePadding: 50
		  },
          600:{
            items: 1,
			nav: false,
            stagePadding: 50
          },
          599:{
            items: 1,
			nav: false,
            stagePadding: 150
          },
          768:{
            items: 1,
			nav: false,
            stagePadding: 150
          },
          991:{
            items: 1,
			nav: false,
            stagePadding: 250
          },
          1024:{
            items: 2,
			nav: true,
           stagePadding: 100
          },
           1366:{
            items: 3,
			nav: true,
            stagePadding: 60
          },
          1440:{
            items: 2,
			nav: true,
            stagePadding: 70
          }
          
		  
		}
	})
 })

//collection_slider
$(document).ready(function() {
   $('.collection_slider').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:3,
		autoplay: true,
        nav:false,
        autoplayTimeout: 10000,
        smartSpeed: 1400,
		dots: true,
		dotsEach: 1,
		responsiveClass: true,
        autoHeight: true,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 1,
			nav: false,
           
		  },
          390:{
            items: 1,
			nav: false,
           
          },
          600:{
            items: 1,
			nav: false
          },
          768:{
            items: 1,
			nav: false
          },
          991:{
            items: 1,
			nav: false,
          
          },
         1024:{
            items: 1,
			nav: true,
          
          },
          1440:{
            items:1,
			nav: true
          }
          
		  
		}
	})
 })

// about slider
$(document).ready(function() {
   $('.about-slider-section .achievement-section').owlCarousel({
		loop: true,
	    margin: 25,
        // navText: ["<i class=\"fa-solid fa-arrow-left\"></i>","sdasddasd<i class=\"fa-solid fa-arrow-right\"></i>"],
		items:7,
		autoplay: false,
        nav:true,
        autoplaySpeed: 4500,
        slideTransition: 'linear',
        autoplayTimeout: 5000,
        lazyLoad: true,
		dots: false,
		dotsEach: 1,
		responsiveClass: true,
        stagePadding: 250,
        autoHeight: false,
        responsiveBaseElement: 'body',
		responsive: {
		  0: {
			items: 1,
			nav: false,
            margin: 18,
            stagePadding: 55,
		  },
          390:{
            items: 1,
			nav: true,
            stagePadding: 55,
          },
          599:{
            items: 1,
			nav: true,
            stagePadding: 55,
          },
          600:{
            items: 1,
			nav: true,
            stagePadding: 210,
          },
          768:{
            items: 1,
			nav: true,
            stagePadding: 210,
          },
          991:{
            items: 3,
			nav: true,
            stagePadding: 60,
          },
           1024:{
            items: 3,
			nav: true,
            stagePadding: 78,
          },
          1240:{
            items: 3,
             stagePadding: 78,
			nav: true
          },
        
          1440:{
            items: 3,
             stagePadding: 250,
			nav: true
          }
		  
		}
	});
 });

// owl-slider script...
    // $(document).ready(function () {
    //     $(".left-arrow").on("click", function () {
    //         $(".owl-carousel").trigger("prev.owl.carousel");
    //     });
    // });

    // $(document).ready(function () {
    //     $(".right-arrow").on("click", function () {
    //         $(".owl-carousel").trigger("next.owl.carousel");
    //     });
    // });




$(document).ready(function() {
    var owl1 = $('.about-slider-section .achievement-section');
    owl1.owlCarousel();
    
    $('.left-arrow').click(function () {
        owl1.trigger('prev.owl.carousel');
    });
    
    $('.right-arrow').click(function () {
        owl1.trigger('next.owl.carousel');
    });
});


$(function(){
  $('.banner_content').animate({ scrollTop: $('.banner_content').height() }, 0);
  $(window).scroll(function(){
    // var aTop = $('header.header').height();
    if ($(window).scrollTop() >= 5) {
        // alert('header just passed.');
        $('.banner_content').animate({ scrollTop: 0 }, 2000);
        
      $('.banner_section').addClass('bg-img');
        // setTimeout(function() {
        // $('.banner_section').addClass('bg-img');
          // $('.banner_section').removeClass('bg-img-zoom');
        // }, 2000);
      $('body').css('overflow-x','hidden');
      $('.home-popslider-section').addClass('fadeup');
    }

    // var bTop = $('.banner_section').height();
    // if($(this).scrollTop()>=bTop){
        
    //   $('.home-popslider-section').addClass('fadeup');
    // }

    var aTop = $('body.home-page .banner_section').height();
     if($(this).scrollTop()>=aTop){
        $('body.home-page .header.header').addClass('scrolled-past-header');
     }
    else if ($(window).scrollTop() <= 0){
      $('body.home-page .header.header').removeClass('scrolled-past-header');
    }
    if($(this).scrollTop()>=aTop){
        $('body.home-page .header.header').addClass('scrolled-past-header');
     }
    else if ($(window).scrollTop() <= 0){
      $('body.home-page .header.header').removeClass('scrolled-past-header');
    }
  });
});
  $(document).ready(function () {
      var animatedElement = $('.popup-cut-image');

      // Disable scroll on animation start
      animatedElement.on('animationstart', function () {
        $('body').addClass('scroll-disabled');
        event.preventDefault();
      });

      // Enable scroll on animation end
      animatedElement.on('animationend', function () {
        $('body').removeClass('scroll-disabled');
      });
    });



//inner-page sticky header.....
$(window).scroll(function() {
    if ($(this).scrollTop() > 38){  
        $('body.inner-page .header').addClass("scrolled-past-header");
    }
    else{
        $('body.inner-page .header').removeClass("scrolled-past-header");
    }
});


$('body.inner-page .header').addClass("mega-menu");
$('body.home-page .header').addClass("mega-menu");

$(document).ready(function() {
  
  if ($('body').hasClass('page.Terms-Conditions')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.shipping-policy')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.Refund Policy')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.marketing')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.become-affiliate-partner')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('article')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.contact')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.career')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.about-us')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
  if ($('body').hasClass('page.privacy-policy')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.become-partner')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
   if ($('body').hasClass('page.sitemap')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
 if ($('body').hasClass('page')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
 if ($('body').hasClass('page.quality-policy')) {
    $('body').addClass('new-mega-menu');
    $('.header').removeClass('mega-menu');
  }
  
});




//click to copy....
function myFunction(element) {
  // Create a range and select the text content of the element
  var range = document.createRange();
  range.selectNodeContents(element);

  // Create a selection and remove any existing selections
  var selection = window.getSelection();
  selection.removeAllRanges();

  // Add the range to the selection
  selection.addRange(range);

  // Copy the selected text to the clipboard
  document.execCommand('copy');

  // Remove the selection to avoid interfering with other interactions
  selection.removeAllRanges();
}


// sidebar product detail page....
	function openNav() {
	var sidenav = document.getElementById("mySidenav");
    sidenav.style.width = (window.innerWidth < 600) ? "100%" : "439px";
	}
	function closeNav() {
	    document.getElementById("mySidenav").style.width = "0";
	}



if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1){
    $('body').addClass('mac_os');
}

// mac-os class
function mac_class() {
  if (navigator.userAgent.indexOf('Mac') >= 0) {
    $('body').addClass('mac_os');
  } else {
    $('body').removeClass('mac_os');
  }
  if (navigator.userAgent.indexOf('Linux') >= 0) {
    $('body').addClass('mac_os');
  }else {
    $('body').removeClass('mac_os');
  }
  if (navigator.userAgent.indexOf('iPhone') >= 0) {
    $('body').addClass('mac_os');
  }else {
    $('body').removeClass('mac_os');
  }
  if (navigator.userAgent.indexOf('iPad') >= 0) {
    $('body').addClass('mac_os');
  }else {
    $('body').removeClass('mac_os');
  }
}







function change_font_numbers(){

   if($('.discount-info-main p').length > 0) {
      $('.discount-info-main p').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);

      });

    }

  
  if($('.discount-main h2').length > 0) {
      $('.discount-main h2').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);

      });

    }
  

    if($('.header__inline-menu .gm-description').length > 0) {
      $('.header__inline-menu .gm-description').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);

      });

    }

  

    if($('.header__inline-menu .gm-text').length > 0) {
      $('.header__inline-menu .gm-text').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);

      });

    }

  

    //homepage text changes

    if($('.popup-flex .popslider-section').length > 0) {
      $('.popup-flex .popslider-section').each(function(i, obj) {
        var text = $(this).find('.info-part h2.car-title').html();
       var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).find(".info-part h2.car-title").html(newText);

      });

    }



    if($('.home-about-section .info-section').length > 0) {
      $('.home-about-section .info-section').each(function(i, obj) {
      var text = $(this).find('p').html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).find("p").html(newText);
      });

    }



    if($('.flex-product p.sub_text_product').length > 0) {
      var text = $('.flex-product p.sub_text_product').html();
      var newText = text.replace(/\b(\d+(?:st|nd|rd|th)?)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
      $('.flex-product p.sub_text_product').html(newText);

    }


    if($('.product-grid .scroll-trigger').length > 0) {
      $('.product-grid .scroll-trigger').each(function(i, obj) {
        var text = $(this).find('.card__heading a').html();
        var newText = text.replace(/\b(\d+(?:pc|pcs)?)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).find(".card__heading a").html(newText);
      });

    }


    //collections page text changes

    if($('.collection_banner_section .collect_grid').length > 0) {
      $('.collection_banner_section .collect_grid').each(function(i, obj) {
        var text = $(this).find('h2.col_heading').html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).find("h2.col_heading").html(newText);
      });

    }


    if($('.gf-filter-contents .gf-option-box .gf-label').length > 0) {
      $('.gf-filter-contents .gf-option-box .gf-label').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);
      });

    }


    if($('.deals-info .dealsinfo-part h2').length > 0) {
      $('.deals-info .dealsinfo-part h2').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);
      });

    }


    //product page text changes

    if($('.ship-text p').length > 0) {
      var text = $('.ship-text p').html();
      var img_src = $('.ship-text p img').attr('src');
      var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
      $('.ship-text p').html(newText);
      $('.ship-text p img').prop('src',img_src);

    }


    if($('.feature-info-part p').length > 0) {

      var text = $('.feature-info-part p').html();
      var newText = text.replace(/\b(\d+(?:g|gm|k|kg)?)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
      $('.feature-info-part p').html(newText);

    }

  if ($('.feature-info-part h3').length > 0) {
    var text = $('.feature-info-part h3').html();
    var newText = text.replace(/\b(\d+(?:g|gm|k|kg)?)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
    newText = newText.replace(/(\d+ml)/g, "<span class='num-font'>$1</span>");
    $('.feature-info-part h3').html(newText);
}

    if($('.repeater-part .background-set h4').length > 0) {

      $('.repeater-part .background-set h4').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+(?:m|M|L|l)?)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);

      });

    }

    if($('.footer__copyright .copyright__content').length > 0) {
      var text = $('.footer__copyright .copyright__content').html();
      var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
      $('.footer__copyright .copyright__content').html(newText);

    }

    //about page text change

    if($('.stand-desc p').length > 0) {
      var text = $('.stand-desc p').html();
      var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
      $('.stand-desc p').html(newText);

    }

    if($('.achievement-section .about-slider-info p').length > 0) {
      $('.achievement-section .about-slider-info p').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);
      });

    }

    //contact page text change

    if($('.contact-info-flex h4').length > 0) {
      $('.contact-info-flex h4').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    //policy text change

    if($('.career-flex-part p').length > 0) {
      $('.career-flex-part p').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font-normal'>$1</span>");
        $(this).html(newText);
      });

    }

    if($('.career-flex-part h3').length > 0) {
      $('.career-flex-part h3').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    //marketing page text change

    if($('.showcase-info span').length > 0) {
      $('.showcase-info span').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    if($('.event-info-section h2').length > 0) {
      $('.event-info-section h2').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    //blogs page text change

    if($('.featuree-blog-section .right-info-part h3').length > 0) {
      $('.featuree-blog-section .right-info-part h3').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    if($('.article-card__info.caption-with-letter-spacing.h5').length > 0) {
      $('.article-card__info.caption-with-letter-spacing.h5').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });

    }

    if($('.rb_contents span').length > 0) {
      $('.rb_contents span').each(function(i, obj) {
        var text = $(this).html();
        var newText = text.replace(/\b(\d+)\b(?![^<]*<\/span>)/g, "<span class='num-font'>$1</span>");
        $(this).html(newText);
      });
    }
}


setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 1000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 2000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 3000); 
setTimeout(function() {
  mac_class();
  
  change_font_numbers();
}, 4000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 5000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 5000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 7000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 8000); 
setTimeout(function() {
  mac_class();
  
   change_font_numbers();
}, 9000); 
setTimeout(function() {
  mac_class();
   change_font_numbers();
}, 10000); 


$('.homepage-bottom-section a.show_more').click(function(e) {
  e.preventDefault();
  $(this).parent().find('.hide-section').toggleClass('show');
});



$(document).ready(function(){
    change_font_numbers();
});





//by me
$(document).ready(function(){
  $('button.shopify-payment-button__button1').click(function(e){
    e.preventDefault();
    window.location.href = 'https://involveyoursenses.com/pages/payment';
  });
  setTimeout(function(){ payment_info(); }, 1000);
  setTimeout(function(){ payment_info(); }, 2000);
  setTimeout(function(){ payment_info(); }, 3000);
  setTimeout(function(){ payment_info(); }, 4000);
  function payment_info(){
    let inrAmount = parseFloat($('#payment_calc').val() / 100).toFixed(2);
    let exchangeRate = 87; // Example rate, update as needed
    let usdAmount = (inrAmount / exchangeRate).toFixed(2);
    $('#payment_total b').text(usdAmount);
    // console.log(`₹${inrAmount} = $${usdAmount}`);
  }
  
});
//by me